<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li v-access:can="Const.PERMISSION_ROLE_ADMIN"><a href="/companies">{{ $t('companies') }}</a></li>
					<li><span>{{ action === 'edit' ? name : $t('create.company') }}</span></li>
				</ul>
			</div>

			<div class="row">
				<div class="col-sm-12">
					<div class="sidebar">
						<button id="sidebar_save" type="submit" :title="$t('save')">
							<span uk-icon="save"></span>
							<span class="title">{{ $t('save') }}</span>
						</button>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-sm-12">
					<div class="form form-with-sidebar">
						<div class="row">
							<div class="col-sm-12">
								<div class="form-body">

									<div class="form-content">
										<div class="row control-container">
											<p class="form-group-name">{{ $t('company.profile') }}</p>

											<div class="col-sm-6">
												<div class="row">
													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_name">{{ $t('name') }}</label>
														</div>
														<div class="col-sm-9">
															<input id="company_name" class="textInput attribute-editor"
																   type="text">
															<button class="button_reset fa fa-times"></button>
														</div>
													</div>
													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_type">{{ $t('company.type') }}</label>
														</div>
														<div class="col-sm-9">
															<select id="company_type"
																	class="textInput attribute-editor"
																	v-model="type">
																<option v-for="value in types" :key="value" :value="value">
																	{{ $t(value) }}
																</option>
															</select>
														</div>
													</div>
													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_role">{{ $t('company.role') }}</label>
														</div>
														<div class="col-sm-9">
															<select id="company_role"
																	class="textInput attribute-editor"
																	v-model="role"
																	v-if="isAdmin">
																<option v-for="value in roles" :key="value" :value="value">
																	{{ $t(value) }}
																</option>
															</select>
															<p v-else class="textInput attribute-editor locked">{{ $t(role) }}</p>
														</div>
													</div>
													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_gln">{{ $t('company.gln') }}</label>
														</div>
														<div class="col-sm-9">
															<input id="company_gln" class="textInput attribute-editor"
																   type="text">
															<button class="button_reset fa fa-times"></button>
														</div>
													</div>
													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_code">{{ $t('company.code') }}</label>
														</div>
														<div class="col-sm-9">
															<input id="company_code" class="textInput attribute-editor"
																   type="text">
															<button class="button_reset fa fa-times"></button>
														</div>
													</div>
													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_description">{{ $t('description') }}</label>
														</div>
														<div class="col-sm-9">
                                                <textarea id="company_description"
														  class="textarea attribute-editor"></textarea>
															<button
																class="button_reset single-area-reset fa fa-times"></button>
														</div>
													</div>
												</div>
											</div>

											<div class="col-sm-6" id="company_secondary-group">
												<div class="row">
													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_valueAddedTax">{{ $t('value.added.tax') }}</label>
														</div>
														<div class="col-sm-9">
															<input id="company_valueAddedTax"
																   class="textInput attribute-editor"
																   type="text">
															<button class="button_reset fa fa-times"></button>
														</div>
													</div>

													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label
																for="company_streetAndNumber">{{ $t('street.and.number')}}</label>
														</div>
														<div class="col-sm-9">
															<input id="company_streetAndNumber"
																   class="textInput attribute-editor"
																   type="text">
															<button class="button_reset fa fa-times"></button>
														</div>
													</div>

													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_country">{{ $t('countries') }}</label>
														</div>
														<div class="col-sm-9">
															<select id="company_country"
																	class="textInput attribute-editor" v-model="country">
																<option v-for="(value, key) in countries" :key="key" :value="key">
																	{{ $t(value) }}
																</option>
															</select>
														</div>
													</div>

													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_city">{{ $t('city') }}</label>
														</div>
														<div class="col-sm-9">
															<input id="company_city" class="textInput attribute-editor"
																   type="text">
															<button class="button_reset fa fa-times"></button>
														</div>
													</div>

													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_state">{{ $t('state') }}</label>
														</div>
														<div class="col-sm-9">
															<input id="company_state" class="textInput attribute-editor"
																   type="text">
															<button class="button_reset fa fa-times"></button>
														</div>
													</div>

													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_postalCode">{{ $t('postal.code') }}</label>
														</div>
														<div class="col-sm-9">
															<input id="company_postalCode"
																   class="textInput attribute-editor"
																   type="text">
															<button class="button_reset fa fa-times"></button>
														</div>
													</div>

													<div class="col-sm-12 form-group-input" v-if="action !== 'create'">
														<div class="col-sm-3">
															<label>{{ $t('registration.date') }}</label>
														</div>
														<div class="col-sm-9">
															<p class="textInput attribute-editor locked"
															   id="company_registrationDate"></p>
														</div>
													</div>

													<div class="col-sm-12 form-group-input">
														<div class="col-sm-3">
															<label for="company_historyKeepDurationInDays">{{ $t('history.keep.duration.in.days') }}</label>
														</div>
														<div class="col-sm-9">
															<input id="company_historyKeepDurationInDays"
																   class="textInput attribute-editor"
																   type="number" min="0">
															<button class="button_reset fa fa-times"></button>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div v-if="action !== 'create'" class="row control-container">
											<p class="form-group-name additional-group-name">{{ $t('items.managment') }}</p>
											<div class="col-sm-12">
												<div class="row">
													<div class="col-sm-3 col-lg-2 hidden-element"
														 id="company_delete-items-block">
														<label>{{ $t('deleting.items') }}</label>
														<br>
														<button id="company_delete-items"
																class="uk-button uk-button-danger uk-button-small">
															{{ $t('delete.company.items') }}
														</button>
													</div>
													<div class="col-sm-3 col-lg-2 hidden-element"
														 id="company_delete-environment-block"
														 v-access:can="[Const.PERMISSION_ROLE_ADMIN]">
														<label>{{ $t('delete.environment') }}</label>
														<br>
														<button id="company_delete-environment"
																class="uk-button uk-button-danger uk-button-small">
															{{ $t('delete.company.environment') }}
														</button>
													</div>
													<div class="col-sm-3 col-lg-2 hidden-element"
														 id="company_recalculate-item-statuses-block">
														<label>{{ $t('item.status') }}</label>
														<br>
														<button id="company_recalculate-item-statuses"
																class="uk-button uk-button-default uk-button-small">
															{{ $t('recalculate.item.statuses') }}
														</button>
													</div>
													<div class="col-sm-3 col-lg-2 hidden-element"
														 id="company_download-environment-block">
														<label>{{ $t('company.environment') }}</label>
														<br>
														<button id="company_download-environment"
																class="uk-button uk-button-default uk-button-small">
															{{ $t('download.company.environment') }}
															<span class="progress loading fa fa-refresh fa-spin"></span>
														</button>
													</div>
													<div class="col-sm-3 col-lg-2 hidden-element"
														 id="company_upload-environment-block">
														<label>{{ $t('company.environment') }}</label>
														<br>
														<button id="company_upload-environment"
																class="uk-button uk-button-default uk-button-small">
															{{ $t('upload.company.environment') }}
														</button>
													</div>
												</div>
											</div>
										</div>

										<div v-if="action !== 'create'" class="row control-container uk-margin-top">
											<p class="form-group-name additional-group-name">{{ $t('additional.settings') }}</p>
											<div class="data__recovery">
												<div class="col-sm-12">
													<label>{{ $t('date.recovery') }}</label>
													<br>
													<input type="text" id="data__recovery-datepicker"
														   class="data__recovery-datepicker datepicker">
													<button id="data__recovery-button"
															class="uk-button uk-button-default uk-button-small">
														<span id="data__recovery-preloader" style="display: none"
															  class="loading fa fa-refresh fa-spin"></span>
														{{ $t('recovery') }}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Const from 'utils/const'
import { CompanyManager } from '@/core/administration/CompanyManager'
import { initSidebar } from '@/core/support_gui_components/sidebar/sidebar'
import { bindResetButton } from '@/core/input_controls/button/button'
import { removeTabindex } from '@/core/shared'

export default {
	name: 'CompanyProfile',
	metaInfo () {
		return {
			title: this.action === 'edit' ? this.$t('company.profile') : this.$t('create.company')
		}
	},
	components: {
	},
	data() {
		return {
			countries: this.$store.getters.getCountries,
			permissions: this.$store.getters.getPermissions,
			name: null,
			country: 'EE',
			type: null,
			role: null,
			roles: ['PROVIDER', 'CLIENT', 'SYSTEM', 'BANK'],
		}
	},
	computed: {
		isAdmin: function () {
			return this.permissions.includes(Const.PERMISSION_ROLE_ADMIN)
		},
		types: function () {
			return this.isAdmin ? ['SERVICE', 'LEGAL', 'INDIVIDUAL'] : ['LEGAL', 'INDIVIDUAL']
		}
	},
	props: [
		'id',
		'activeAttribute',
		'action'
	],
	mounted () {
		let vm = this;

		function initCompanyManager () {
			let companyManager = new CompanyManager()
			companyManager.setProperties({
				action: vm.action,
				companyId: vm.action !== 'create' ? (vm.id || vm.$store.getters.getProfile.companyId): null,
				activeAttribute: vm.activeAttribute || '',
				admin: !!Const.PERMISSION_ROLE_ADMIN,
				fields: ['name', 'type', 'role', 'gln', 'description', 'code', 'valueAddedTax', 'streetAndNumber', 'city', 'state', 'postalCode', 'country', 'historyKeepDurationInDays']

			})
			if (vm.action !== 'create')
				companyManager.loadCompanyInformation()
			companyManager.initPage()
			companyManager.initDateRecovery()
			if (vm.action === 'edit') {
				vm.name = companyManager.company.name
				vm.type = companyManager.company.type
				vm.country = companyManager.company.country
				vm.role = companyManager.company.role
			}
		}

		initCompanyManager()
		$(document).focus()
		initSidebar(['save'])
		bindResetButton()
		removeTabindex()
	}
}
</script>

<style scoped>
	.progress {
		position: absolute;
		left: 18px;
		top: 55%;
		background-color: #f8f8f8;
		color: #0090D0;
		height: auto;
		display: none;
	}
</style>
